import { useTranslation } from 'react-i18next'
import { TextArea } from '../../forms'
import { useAcfuProgressiveDisclosure } from '../../../hooks'

// PX-3649: free-text reason, required only once the *selected date* (not the window-expansion
// state — see the reviewed fix on PX-3649) is beyond the 3-day default. Joi enforces the actual
// required-ness — see the two validationSchema.ts files, which key off the same
// acfuRequiresExtendedWindowReason field this hook writes. Deliberately no dropdown/reason-code
// taxonomy, per the ticket's explicit MVP decision.
const AcfuExtendedWindowReason = () => {
  const { t } = useTranslation()
  // fallbackWindowInDays is irrelevant here — this component only needs requiresExtendedWindowReason.
  const { requiresExtendedWindowReason } = useAcfuProgressiveDisclosure(0)

  if (!requiresExtendedWindowReason) return null

  return (
    <TextArea
      fullWidth
      InputLabelProps={{ shrink: true }}
      label={t('common.label.acfuExtendedWindowReason')}
      multiline
      name="acfuExtendedWindowReason"
      placeholder={t('common.message.acfuExtendedWindowReasonRequired')}
      rows={4}
      variant="outlined"
    />
  )
}

export { AcfuExtendedWindowReason }
